import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Aggiungi token JWT a tutte le richieste se presente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Gestisci errori di autenticazione
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Token scaduto o non valido
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getProfile: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/me', data),
};

// Stripe
export const stripeAPI = {
  getConfig: () => api.get('/stripe/config'),
  getPlans: () => api.get('/stripe/plans'),
  createCheckoutSession: (priceId) => api.post('/stripe/create-checkout-session', { priceId }),
  getSubscription: () => api.get('/stripe/subscription'),
  createPortalSession: () => api.post('/stripe/create-portal-session'),
  cancelSubscription: () => api.post('/stripe/cancel-subscription'),
  reactivateSubscription: () => api.post('/stripe/reactivate-subscription'),
};

// Admin
export const adminAPI = {
  getUsers: () => api.get('/admin/users'),
  getUser: (id) => api.get(`/admin/users/${id}`),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  getSubscriptions: () => api.get('/admin/subscriptions'),
  cancelSubscription: (id) => api.post(`/admin/subscriptions/${id}/cancel`),
  getStats: () => api.get('/admin/stats'),
  createPlan: (data) => api.post('/admin/plans', data),
  updatePlan: (id, data) => api.put(`/admin/plans/${id}`, data),
  deletePlan: (id) => api.delete(`/admin/plans/${id}`),
};

export default api;
